import React from "react";
import Transition from "react-transition-group/Transition";

function transition(props) {
  return (
    <Transition in={props.show} timeout={100} mountOnEnter unmountOnExit>
      {state => {
        const componentClassess = [
          props.component.base,
          state === "entered" ? props.component.active : ""
        ].join(" ");
        const shadowClassess = [
          props.shadow.base,
          state === "entered" ? props.shadow.active : ""
        ].join(" ");

        return React.Children.map(props.children, child =>
          React.cloneElement(child, { componentClassess, shadowClassess })
        );
      }}
    </Transition>
  );
}

export default transition;
